// store/useMainStore.js
import { create } from "zustand";

const useProjectModelManagementStore = create((set) => ({
    isModalOpen: null,
    setIsModalOpen: (value) => { set({ isModalOpen: value }) },

    popupType:"project",
    setPopupType:(value)=>{set({popupType:value})},

    projects: [],
    setProjects: (value) => {
        { set({ projects: value }) }
    },

    projectInfo:{},
    setProjectInfo:(value)=>{
        {set({projectInfo:value})}
    },
    projectName: null,
    setProjectName: (value) => { set({ projectName: value }) },

    projectDetailInputField: null,
    setProjectDetailInputField: (value) => { set({ projectDetailInputField: value }) },

}));

export default useProjectModelManagementStore;